export default {
	'TASK_LIST': (state, list) => {
		state.list = list.result;
		state.totalPages = list.totalPages;
	}
};
